export default __webpack_public_path__ + "static/media/property_731.ecf231aa.png";